<style
  scoped
  lang="less"
>
  #nav {
    height: 56px;
    width: 100%;
    border-bottom: 1px solid #eee;
    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin:0 auto;
      li {
        height: 52px;
        font-size: 14px;
        letter-spacing: 2px;
        border-bottom: 2px solid white;
      }
      li > a {
        line-height: 54px;
      }

      li:hover > a {
        border-bottom: 2px solid #0077db;
      }

      li:hover .show {
        opacity: 1;
        z-index: 10;
        transition: all 0.3s ease-in-out;
      }
    }

    a {
      color: #282828;
      display: block;

    }
  }

  .init {
    opacity: 0 !important;
    z-index: -1 !important;
  }

  .show {
    position: absolute;
    width: 100%;
    background-color: #f8f8f8;
    opacity: 0;
    z-index: -1;
    top: 141px;
    transition: all 0.3s ease-in-out;
    padding-bottom: 20px;
    left: 0;
    border-bottom:1px solid #ddd;
  }

  .show a {
    color: #5e5e5e !important;
  }

  .show a:hover {
    color: #0077db !important;
  }

  .nav-show-left {
    width: 64%;
  }

  .nav-show-right {
    width: 35%;
  }

  .w50p {
    width: 50%;
  }

  .w25p {
    width: 25%;
  }

  .w950 {
    width: 950px;
  }

  .nav-show {
    display: flex;
  }

  .nav-show-content {
    @nav-show-content-width: 290px;
    width: @nav-show-content-width;
    overflow: hidden;
    &.w2 {
      width: 2* @nav-show-content-width;
    }
    .nav-show-content-list {
      display: flex;
      flex-wrap: wrap;
      a {
        width: @nav-show-content-width;
        span:hover {
          cursor: pointer;
          color: #0077db;
        }
      }
    }
    .nav-show-content-item {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      margin: 32px 0 18px 0;

      &:hover {
        cursor: pointer;
        color: #0077db;
      }
    }
    span {
      font-size: 12px;
      height: 28px;
      line-height: 28px;
      color: #666;
      transition: color 0.3s ease-in-out;
      position: relative;
      overflow: hidden;
    }
    span i {
      position: absolute;
      top: 0px;
      right: -40px;
      font-size: 10px;
      color: #fff;
      text-align: center;
      line-height: 14px;
      width: 37px;
      height: 14px;
      content: '';
      letter-spacing: 0 !important;
      display: block;
      background: url(//v3.cdn.qiyewan.com/tag.png) no-repeat center;
    }
  }


</style>

<template>
  <div id="nav">
    <div class="container">
      <ul>
        <li>
          <router-link
            to="/"
            title="首页">首页</router-link>
        </li>
        <li v-for="cate1 in navProducts" v-on:mouseenter="isHovering = true">
          <router-link
            :to="{ name: 'product-list', params: { cate1: cate1.code }}"
            :title=" cate1.remarks ">{{ cate1.title }}</router-link>
          <section class="show" :class="{'init': !isHovering}">
            <div class="container nav-show">
              <div
                v-for="(cate2,index) in cate1.children"
                class="nav-show-content"
                :class="{w2: cate2.products.length > 8}">
                <router-link :to="{ name: 'product-list', params: { cate1: cate1.code, cate2: cate2.title }}">
                  <div class="nav-show-content-item">{{ cate2.title }}</div>
                </router-link>
                <div class="nav-show-content-list">
                  <router-link
                    v-for="p in cate2.products"
                    :to="{ name: 'product-detail', params: { serialId: p.serialId }}">
                    <span :class="{hot:p.isHot}">{{ p.name }}<i v-if="p.isHot">hot</i></span>
                  </router-link>
                </div>
              </div>
            </div>
          </section>
        </li>
        <li>
          <router-link :to="{ name: 'tax-planing'}"
                        title="增值税合法节税与合理避税方法以及费用">税务筹划</router-link>
        </li>
        <li>
          <router-link to="/ArticleHome"
                       title="新闻资讯">新闻资讯</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import productApi from '../api/product'
  import {mapGetters} from 'vuex'
  import * as types from '../store/mutation-types'

  export default {
    data () {
      return {
        isHovering: false,
      }
    },
    computed: {
      ...mapGetters({
        getRegion: 'getRegion',
        getProducts: 'getProducts',
        getNavProducts: 'getNavProducts',
      }),
      navProducts(){
        return this.getNavProducts.filter(a => a.code !== 'TP')
      },
      regionCode(){
//        debugger
        return this.getRegion.code
      }
    },
    watch: {
      regionCode: 'fetchData',
      $route () {
        this.isHovering = false
        this.fetchData()
      }
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      async fetchData () {
//        debugger
        try {
          await this.$store.dispatch('fetchProducts', this.getRegion.code)
        }
        catch (error) {
          this.error = error
          console.log(`[Header#fetchData: error=${error}`)
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// Header.vue?70c88de2